import { render, staticRenderFns } from "./SwitchoverBanner.vue?vue&type=template&id=037d655f&scoped=true&"
import script from "./SwitchoverBanner.vue?vue&type=script&lang=js&"
export * from "./SwitchoverBanner.vue?vue&type=script&lang=js&"
import style0 from "./SwitchoverBanner.vue?vue&type=style&index=0&id=037d655f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "037d655f",
  null
  
)

export default component.exports